class CollectionLoadMore {
  static init() {
    this.bindEvents();
    this.initStickyFacets();
    this.initBannerProductStacks();

    window.addEventListener('resize', () => {
      this.initBannerProductStacks();
    });
  }

  static bindEvents() {
    document.addEventListener('click', (e) => {
      const loadMoreBtn = e.target.closest('.js-load-more-btn');

      if (loadMoreBtn) {
        e.preventDefault();
        this.loadMore(loadMoreBtn);
        return;
      }

      const soundBtn = e.target.closest('.js-video-sound-toggle');

      if (soundBtn) {
        e.preventDefault();

        const wrapper = soundBtn.closest('.js-collection-top-media');
        if (!wrapper) return;

        const video = wrapper.querySelector('video');
        if (!video) return;

        const iconOff = soundBtn.querySelector('.js-icon-off');
        const iconOn = soundBtn.querySelector('.js-icon-on');
        const textOff = soundBtn.querySelector('.js-text-off');
        const textOn = soundBtn.querySelector('.js-text-on');

        video.muted = !video.muted;

        if (video.muted) {
          if (iconOff) iconOff.classList.remove('d-none');
          if (iconOn) iconOn.classList.add('d-none');
          if (textOff) textOff.classList.remove('d-none');
          if (textOn) textOn.classList.add('d-none');
        } else {
          if (iconOff) iconOff.classList.add('d-none');
          if (iconOn) iconOn.classList.remove('d-none');
          if (textOff) textOff.classList.add('d-none');
          if (textOn) textOn.classList.remove('d-none');
        }
      }
    });
  }

  static async loadMore(btn) {
    const url = btn.dataset.url;
    if (!url) return;

    if (!btn.dataset.originalText) {
      btn.dataset.originalText = btn.textContent.trim();
    }

    if (btn.dataset.loadingText) {
      btn.textContent = btn.dataset.loadingText;
    }

    btn.classList.add('is-loading');
    btn.disabled = true;

    try {
      const res = await fetch(url);
      const text = await res.text();

      const html = new DOMParser().parseFromString(text, 'text/html');

      const newItems = html.querySelector('.js-collection-results');
      const currentItems = document.querySelector('.js-collection-results');
      const newPagination = html.querySelector('.js-load-more-wrapper');

      if (!newItems || !currentItems) {
        throw new Error('Collection results not found');
      }

      newItems.querySelectorAll(':scope > *').forEach((el) => {
        currentItems.appendChild(el);
      });

      window.history.replaceState({}, '', url);

      if (newPagination && newPagination.dataset.url) {
        btn.dataset.url = newPagination.dataset.url;
        btn.disabled = false;
        btn.classList.remove('is-loading');
        btn.textContent = btn.dataset.originalText;
      } else {
        btn.remove();
      }

      this.updateCounter(html);
      this.initBannerProductStacks();

      if (typeof initializeObservers === 'function') {
        initializeObservers();
      }

      if (typeof window.observeGridItems === 'function') {
        window.observeGridItems();
      }

      if (typeof ProductGridLazyVariants !== 'undefined') {
        ProductGridLazyVariants.updateMobileVisibility();
      }
    } catch (err) {
      console.error(err);
      btn.disabled = false;
      btn.classList.remove('is-loading');

      if (btn.dataset.originalText) {
        btn.textContent = btn.dataset.originalText;
      }
    }
  }

  static updateCounter(html) {
    const viewedEl = document.querySelector('.js-viewed-count');
    const newViewedEl = html.querySelector('.js-viewed-count');

    if (!viewedEl || !newViewedEl) return;
    viewedEl.textContent = newViewedEl.textContent.trim();
  }

  static initBannerProductStacks() {
    const rows = document.querySelectorAll('.js-collection-results');
    if (!rows.length) return;

    rows.forEach((row) => {
      this.resetBannerProductStacks(row);

      if (window.innerWidth < 768) return;

      const bannerCols = Array.from(
        row.querySelectorAll(':scope > .col-collection-banner')
      ).filter((col) => {
        if (!col.querySelector('.js-collection-banner-with-product')) return false;
        return col.offsetParent !== null;
      });

      if (!bannerCols.length) return;

      const usedProducts = new Set();

      bannerCols.forEach((bannerCol) => {
        this.buildStacksForBanner(row, bannerCol, usedProducts);
      });
    });
  }

  static buildStacksForBanner(row, bannerCol, usedProducts) {
    if (
      window.innerWidth >= 768 &&
      window.innerWidth < 992 &&
      bannerCol.classList.contains('col-md-12')
    ) {
      return;
    }
    
    const children = Array.from(row.children).filter((el) => el.offsetParent !== null);
    const bannerIndex = children.indexOf(bannerCol);

    if (bannerIndex === -1) return;

    const after = children
      .slice(bannerIndex + 1)
      .filter((el) => this.isProductColumn(el) && !usedProducts.has(el));

    const before = children
      .slice(0, bannerIndex)
      .filter((el) => this.isProductColumn(el) && !usedProducts.has(el));

    if (window.innerWidth < 992) {
      const next1 = after[0];
      const next2 = after[1];

      if (!next1 || !next2) return;

      usedProducts.add(next1);
      usedProducts.add(next2);

      const stack = this.createProductStack([next1, next2], row);
      if (!stack) return;

      row.insertBefore(stack, bannerCol.nextSibling);
      return;
    }

    const isLargeProductLayout = this.isLargeProductGridLayout(row);

    if (isLargeProductLayout) {
      const placement = this.getBannerPlacementInVisualRow(row, bannerCol);

      if (placement === 'right') {
        const prev2 = before[before.length - 2];
        const prev1 = before[before.length - 1];

        if (!prev2 || !prev1) return;

        usedProducts.add(prev2);
        usedProducts.add(prev1);

        const stack = this.createProductStack([prev2, prev1], row);
        if (!stack) return;

        row.insertBefore(stack, bannerCol);
        return;
      }

      const next1 = after[0];
      const next2 = after[1];

      if (!next1 || !next2) return;

      usedProducts.add(next1);
      usedProducts.add(next2);

      const stack = this.createProductStack([next1, next2], row);
      if (!stack) return;

      row.insertBefore(stack, bannerCol.nextSibling);
      return;
    }

    const placement = this.getBannerPlacementInVisualRow(row, bannerCol);

    if (placement === 'right') {
      const prev2 = before[before.length - 2];
      const prev1 = before[before.length - 1];
      const next1 = after[0];
      const next2 = after[1];

      if (!prev2 || !prev1 || !next1 || !next2) return;

      usedProducts.add(prev2);
      usedProducts.add(prev1);
      usedProducts.add(next1);
      usedProducts.add(next2);

      const firstStack = this.createProductStack([prev2, next1], row);
      const secondStack = this.createProductStack([prev1, next2], row);

      if (!firstStack || !secondStack) return;

      row.insertBefore(firstStack, bannerCol);
      row.insertBefore(secondStack, bannerCol);
      return;
    }

    if (placement === 'middle') {
      const prev1 = before[before.length - 1];
      const next1 = after[0];
      const next3 = after[2];
      const next4 = after[3];

      if (!prev1 || !next1 || !next3 || !next4) return;

      usedProducts.add(prev1);
      usedProducts.add(next1);
      usedProducts.add(next3);
      usedProducts.add(next4);

      const firstStack = this.createProductStack([prev1, next3], row);
      const secondStack = this.createProductStack([next1, next4], row);

      if (!firstStack || !secondStack) return;

      row.insertBefore(firstStack, bannerCol);
      row.insertBefore(secondStack, bannerCol.nextSibling);
      return;
    }

    const next1 = after[0];
    const next2 = after[1];
    const next3 = after[2];
    const next4 = after[3];

    if (!next1 || !next2 || !next3 || !next4) return;

    usedProducts.add(next1);
    usedProducts.add(next2);
    usedProducts.add(next3);
    usedProducts.add(next4);

    const firstStack = this.createProductStack([next1, next3], row);
    const secondStack = this.createProductStack([next2, next4], row);

    if (!firstStack || !secondStack) return;

    row.insertBefore(firstStack, bannerCol.nextSibling);
    row.insertBefore(secondStack, firstStack.nextSibling);
  }

  static isLargeProductGridLayout(row) {
    const firstProduct = Array.from(row.children).find((el) => this.isProductColumn(el));
    if (!firstProduct) return false;

    return (
      firstProduct.classList.contains('col-12') &&
      firstProduct.classList.contains('col-md-6') &&
      firstProduct.classList.contains('col-lg-4')
    );
  }

  static getBannerPlacementInVisualRow(row, bannerCol) {
    const visibleChildren = Array.from(row.children).filter((el) => el.offsetParent !== null);
    const bannerTop = bannerCol.offsetTop;
    const tolerance = 6;

    const sameVisualRow = visibleChildren
      .filter((el) => Math.abs(el.offsetTop - bannerTop) <= tolerance)
      .sort((a, b) => a.offsetLeft - b.offsetLeft);

    const bannerPos = sameVisualRow.indexOf(bannerCol);

    if (bannerPos <= 0) return 'left';
    if (bannerPos === sameVisualRow.length - 1) return 'right';
    return 'middle';
  }

  static createProductStack(products, row) {
    if (!products || products.length !== 2) return null;

    const stack = document.createElement('div');

    if (this.isLargeProductGridLayout(row)) {
      stack.className = 'col-12 col-md-6 col-lg-4 js-product-stack';
    } else {
      stack.className = 'col-12 col-md-4 col-lg-3 js-product-stack';
    }

    products.forEach((product) => {
      if (!product.dataset.originalClassName) {
        product.dataset.originalClassName = product.className;
      }

      product.classList.add('js-product-stack-item');
      product.classList.remove(
        'col-12',
        'col-6',
        'col-md-4',
        'col-md-6',
        'col-md-8',
        'col-lg-3',
        'col-lg-4',
        'col-lg-6',
        'col-lg-8'
      );

      stack.appendChild(product);
    });

    return stack;
  }

  static resetBannerProductStacks(row) {
    const stacks = row.querySelectorAll(':scope > .js-product-stack');

    stacks.forEach((stack) => {
      const items = Array.from(
        stack.querySelectorAll(':scope > .js-product-stack-item')
      );

      items.forEach((item) => {
        if (item.dataset.originalClassName) {
          item.className = item.dataset.originalClassName;
        } else {
          item.classList.remove('js-product-stack-item');
        }

        row.insertBefore(item, stack);
      });

      stack.remove();
    });
  }

  static isProductColumn(el) {
    if (!el) return false;
    if (el.classList.contains('col-collection-banner')) return false;
    if (el.classList.contains('js-product-stack')) return false;

    return !!el.querySelector('.js-product-grid-item');
  }

  static initStickyFacets() {
    const facets = document.querySelector('collection-facets');
    const sticky = document.querySelector('.js-sticky-facets');

    if (!facets || !sticky) return;

    let hideTimeout = null;
    const TOP_VH = 0.3;

    function inTop30vhZone() {
      const f = facets.getBoundingClientRect();
      const line = window.innerHeight * TOP_VH;
      return f.top <= line && f.bottom >= line;
    }

    function stickyOutsideBottom() {
      const f = facets.getBoundingClientRect();
      const s = sticky.getBoundingClientRect();
      return s.bottom > f.bottom;
    }

    function clearHideTimer() {
      if (hideTimeout) {
        clearTimeout(hideTimeout);
        hideTimeout = null;
      }
    }

    function scheduleHideIfStillOutside() {
      if (hideTimeout) return;
      hideTimeout = setTimeout(() => {
        if (!inTop30vhZone() || stickyOutsideBottom()) {
          sticky.classList.add('hide');
        }
        hideTimeout = null;
      }, 200);
    }

    function check() {
      if (!inTop30vhZone()) {
        scheduleHideIfStillOutside();
        return;
      }

      if (stickyOutsideBottom()) {
        scheduleHideIfStillOutside();
      } else {
        clearHideTimer();
        sticky.classList.remove('hide');
      }
    }

    check();
    window.addEventListener('scroll', check, { passive: true });
    window.addEventListener('resize', check);
  }
}

window.CollectionLoadMore = CollectionLoadMore;

document.addEventListener('DOMContentLoaded', () => {
  window.CollectionLoadMore.init();
});